import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as serviceWorker from './serviceWorker';
import TagManager from 'react-gtm-module';
import 'mapbox-gl/dist/mapbox-gl.css';
// Registers the north arrow + scale bar on every Leaflet map in the app.
import '@iso/lib/helpers/mapFurniture';
// Draws segment lengths and area onto every path. Imported after the furniture
// because it reads the shared metric/imperial preference from it.
import '@iso/lib/helpers/mapMeasurements';
import './custom.css';
const tagManagerArgs = {
    gtmId: 'GTM-NJKCDB7'
} 
TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
